"use client";
import React, { useState, useRef, useEffect } from "react";
import { usePathname } from "next/navigation";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faCaretDown, faCaretRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import Link from "next/link";

interface SubLink {
  title: string;
  path: string;
  additionalFields: Record<string, any>;
}

interface NavLink {
  title: string;
  path: string;
  items: SubLink[];
  additionalFields: Record<string, any>;
}

interface DesktopNavLinkProps {
  link: NavLink;
}

const DesktopNavLink: React.FC<DesktopNavLinkProps> = ({ link }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const pathname = usePathname();

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShowDropdown(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowDropdown(false);
    }, 150);
  };

  return (
    
    <div 
      className="relative group"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className={`flex items-center px-[2px] lg:px-[1px] py-1 hover:bg-[#F5F5F5] text-xs lg:text-sm ${pathname === link.path ? 'bg-[#F5F5F5]' : 'text-gray-700'}`}>
        <a href={link.items?.length > 0 ? undefined : link.path} className="mr-1">
          {link.additionalFields.view}
        </a>
        {link.items?.length > 0 && (
          <FontAwesomeIcon 
            icon={faCaretDown} 
            className={`w-3 h-3 transition-transform duration-200 ${showDropdown ? 'rotate-180' : ''}`}
          />
        )}
      </div>

      {link.items?.length > 0 && showDropdown && (
        <div className="absolute left-0 mt-0 w-48 bg-[#F5F5F5] rounded-md shadow-md z-10">
          <div className="py-1">
            {link.items.map((subLink) => (
              <a
                key={subLink.path}
                href={`${link.path}/${subLink.path}`}
                className="block px-4 py-2 text-xs text-[#09476C] hover:bg-[#FFFFFF]"
              >
                {subLink.additionalFields.view}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default DesktopNavLink;

